define.alias("shared/components/shared/pre-boarding/survey/index", "calendar/components/shared/pre-boarding/survey/index");